

export const savings_account = [
  {
    id: 1,
    title: "Personal",
    number: "**** **** **** 7523",
    balance: "437,192 EGP"
  },
  {
    id: 2,
    title: "Car",
    number: "**** **** **** 5124",
    balance: "393,432 EGP"

  },
]

export const current_account = [
  {
    id: 1,
    title: "Personal",
    number: "**** **** **** 9786",
    balance: "657,328 EGP"
  },
]